import {GroundTeamEventLogTypes} from "./groundTeamEventLog.types";

const INITIAL_STATE = {
  groundTeamEventLogs: []
};

const consoleEventLogReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GroundTeamEventLogTypes.SET_GROUND_TEAM_EVENT_LOGS:
      return {
        ...state,
        groundTeamEventLogs: action.payload,
      };
    default:
      return state;
  }
};

export default consoleEventLogReducer;